var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda;

  return "Thank you! We registered your comment.\nIf you want to track the issue progress, save this link:\n["
    + ((stack1 = alias1(depth0, depth0)) != null ? stack1 : "")
    + "|"
    + ((stack1 = alias1(depth0, depth0)) != null ? stack1 : "")
    + "]";
},"useData":true});